import React from "react";

const Confimation = () => {
  return <div>confirmation</div>;
};

export default Confimation;
